import { Fragment, useState } from "react";
import _ from "lodash";

import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
//import variableApi from "../../api/variableApi";
import { dataValidator } from "../../tools/dataValidator";
import VariableDesignerTable from "./VariableDesignerTable";
import VariableDesignerSensor from "./VariableDesignerSensor";
import ActionButton from "../Commons/ActionButton";
import VariableDesignerValidation from "./VariableDesignerValidation";

import { getLabel } from "../../tools/Dictionary";
import { MdOutlineRemoveRedEye, MdMode, MdContentCopy } from "react-icons/md";

const VariableDesignerModal = (props) => {

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const Id = props.Id;
  //const ProcessId = props.ProcessId;
  const VariableType = props.VariableType;
  const OnCloseModal = props.OnCloseModal;
  const LoadData = props.LoadData;
  const NextOrder = props.NextOrder;
  const OnDuplicate = props.OnDuplicate;
  const DuplicateData = props.DuplicateData;
  const ValidateVariableChange = props.ValidateVariableChange;
  const Variable = props.Variable;
  const OnConfirm = props.OnConfirm;

  //State
  const [form, setForm] = useState({
    
  });
  const [originalValue, setOriginalValue] = useState({
  });
  const [validation, setValidation] = useState([]);
  const [error, setError] = useState({

  });
  const [loading, setLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(Id && Id != 0);
  const [tableModal, setTableModal] = useState(false);
  const [sensorModal, setSensorModal] = useState(false);
  const [variableType, setVariableType] = useState(VariableType);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });



  //Variables
  const baseForm = {
    _id: 0,
    name: "",
    description: "",
    variableType: undefined,
    variableTypeCode: "",
    variableTypeLabel: {},
    data: {},
    dataToDisplay: "",
    isParameter: false,
    parameterOption: [],
    order: NextOrder || 10
  }


  useMount(() =>
  {
    loadData();
  }, []);


  const loadData = async () =>
  {

    console.log("VariableDesignerModal loadData");
    if (isUpdate)
    {

      try
      {
        const currentVariable = Variable.find(v => v._id == Id);


        setForm({
          _id: currentVariable._id,
          name: currentVariable.name,
          description: currentVariable.description,
          variableType: currentVariable.variableType,
          variableTypeCode: currentVariable.variableTypeCode,
          variableTypeLabel: currentVariable.variableTypeLabel,
          data: currentVariable.data,
          dataToDisplay: currentVariable.dataToDisplay,
          isParameter: currentVariable.isParameter,
          parameterOption: currentVariable.parameterOption,
          isAdded: currentVariable.isAdded,
          isChanged: currentVariable.isChanged,
          order: currentVariable.order
        });

        //Keep a copie of the original
        setOriginalValue({
          _id: currentVariable._id,
          name: currentVariable.name,
          description: currentVariable.description,
          variableType: currentVariable.variableType,
          variableTypeCode: currentVariable.variableTypeCode,
          variableTypeLabel: currentVariable.variableTypeLabel,
          data: currentVariable.data,
          dataToDisplay: currentVariable.dataToDisplay,
          isParameter: currentVariable.isParameter,
          parameterOption: currentVariable.parameterOption,
          isAdded: currentVariable.isAdded,
          isChanged: currentVariable.isChanged,
          order: currentVariable.order
        })


        //Filter Variable Type so the user can't change from incompatible type (Table to Int Number Text)
        setVariableType(VariableType.filter(v => {
          if (currentVariable.variableTypeCode == "int" || currentVariable.variableTypeCode == "number" || currentVariable.variableTypeCode == "text"){
            if (v.code == "sensor") return false;
            else return true;
          }else{
            if (v.code == "sensor") return true;
            else return false;
          }
        }));

        


        setLoading(false);

      } catch (err)
      {


        setAlert({
          Title: getLabel("App", "Error"),
          Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: onFatalError,
          Display: true
        });

      }

    } else
    {

      //Add
      setForm(DuplicateData || baseForm);
      setLoading(false);
    }

  };


  const onFatalError = async () =>
  {

    setAlert(alert => ({ ...alert, Display: false }));

    await LoadData();

    setLoading(false);

    OnCloseModal();

  };


  const onChangeName = (e) => {

    let name = e.target.value;

    if (name.length > 30) return; //Check length

    onValidateField("name", name); //Validate field value

    setForm(form => ({
      ...form,
      name
    }));   

  };

  const onChangeDescription = (e) =>
  {

    let description = e.target.value;

    if (description.length > 100) return; //Check length

    onValidateField("description", description); //Validate field value

    setForm(form => ({
      ...form,
      description
    }));

  };

  const onChangeVariableType = (e) => {

    let _variableType = e.target.value;

    let foundVariableType = variableType.find(v => v._id == e.target.value);

    if (!foundVariableType) return;

    onValidateField("variableType", _variableType); //Validate field value

    let currentData = _.cloneDeep(form.data);
    let currentDataToDisplay = _.cloneDeep(form.dataToDisplay);

    if (form.variableType != variableType){

      switch (foundVariableType.code) {
        case "int":
          currentData = 0;
          currentDataToDisplay = 0;
          break;
        case "number":
          currentData = 0.0;
          currentDataToDisplay = 0.0;     
          break;
        case "text":
          currentData = "";
          currentDataToDisplay = "";
          break; 
        case "table": 
          currentData = {
            numberColumn: 3,
            numberRow: 1,
            column: ["Col1", "Col2", "Col3"],
            row: [
              ["", "", ""]
            ]
          };
          currentDataToDisplay = "[...]"
          break;    
        case "sensor":
          currentData = {
            unit: "celcius",
            tolerance: 5,
            row: [
              {
                temperature: 0,
                resistance: 0
              }
            ]
          };
          currentDataToDisplay = "[...]"
          break;         
        default:
          currentData = "";
          currentDataToDisplay = "";
          break; 
      }

    }


    let isParameter = form.isParameter;

    if (foundVariableType.code != "text" &&
    foundVariableType.code != "int" &&
    foundVariableType.code != "number" ){

      isParameter = false;

    }

    setForm(form => ({
      ...form,
      variableType: foundVariableType._id,
      variableTypeCode: foundVariableType.code,
      variableTypeLabel: foundVariableType.label,
      data: currentData,
      dataToDisplay: currentDataToDisplay,
      isParameter
    }));

  };

  

  const onChangeDataInput = (e) => {

    let data = e.target.value;


    onValidateField("data", data); //Validate field value

    setForm(form => ({
      ...form,
      data
    }));

  }

  const onChangeIsParameter = () =>
  {

    setForm(form => ({
      ...form,
      isParameter: !form.isParameter
    }));

  }

  const onChangeDataTable = (_data) => {


    setForm(form => ({
      ...form,
      data: _data
    }));

  };

  const onChangeDataSensor = (_data) =>
  {


    setForm(form => ({
      ...form,
      data: _data
    }));

  };

  const onChangeOrder = (e) =>
  {

    let order = e.target.value;

    onValidateField("order", order); //Validate field value

    setForm(form => ({
      ...form,
      order
    }));

  };



  // Validate field
  const onValidateField = (field = "", value = "") =>
  {
    let currentError = { ...error }; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];
    let currentField = "";

    let isValid = true; // Flag to track overall validity

    currentField = "name";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      let listVariable = Variable.filter(v => v._id != form._id).map(v => v.name).join("|");

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:30", "notin:" + listVariable] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    currentField = "description"
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:100"] }
      ]);

      Validation = [...Validation, ...currentValidation];
    }

    currentField = "variableType"
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required"] }
      ]);

      Validation = [...Validation, ...currentValidation];
    }

    currentField = "data"
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      let preparedValidation = [];

      if (form.variableTypeCode == "int")
        preparedValidation = ["integer", "max:20"]
      else if (form.variableTypeCode == "number")
        preparedValidation = ["number", "max:30"];
      else if (form.variableTypeCode == "text")
        preparedValidation = ["required", "max:200"];

      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: preparedValidation }
      ]);

      Validation = [...Validation, ...currentValidation];
    }

    currentField = "order";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "integer", "max:4"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }


    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag
  };

  const onClickConfirm = () => {

    try
    {

      if (!onValidateField()) throw new Error("The form contains errors. Please check and fix the fields highlighted in red.");

      if (isUpdate && (form.variableType != originalValue.variableType || form.name != originalValue.name))
      {

        let messageValidation = ValidateVariableChange(
          form,
          form.variableType != originalValue.variableType,
          form.name != originalValue.name
        );



        if (messageValidation.length > 0)
        {

          setValidation(messageValidation);

          // messageValidation.forEach(m => {

          //   console.log(getLabel("variableValidator", m.code, m.parameter));


          // });
        }
      }





      OnConfirm(form);

      OnCloseModal();



    } catch (err)
    {


      setAlert({
        Title: getLabel("App", "Error"),
        Message: getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    }   

  };

  const onClickDelete = () =>
  {

    setConfirm(confirm => ({
      Title: getLabel("App", "Delete"),
      Message: getLabel("App", "Are you sure you want to delete this entity?"),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: onDelete,
      Display: true
    }));

  };

  const onDelete = async () =>
  {

    try
    {

      setConfirm(confirm => ({ ...confirm, Display: false }))

      // setLoading(true);

      // let response = await variableApi.deleteVariable(Id);

      // if (!response.Success)
      // {

      //   let error = new Error("");
      //   error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

      //   throw error;

      // }

      // await LoadData();



      OnConfirm(form, true);

      OnCloseModal();



    } catch (err)
    {
      await LoadData();

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: OnCloseModal,
        Display: true
      });

    };

  }


  const displayDataForm = () => {



    if (form.variableTypeCode == "int" || form.variableTypeCode == "number" || form.variableTypeCode == "text"){
      return (
        <input
          className={"page_text_input " + (error["name"] ? "page_modal_body_col_input_error" : "")}
          value={form.data || form.data == 0 ? form.data : ""}
          onChange={onChangeDataInput}
          type="text"
          style={{ width: "100%" }}
          disabled={!Access.canWrite || loading || ReadOnly}
        />
      )    
    }else if (form.variableTypeCode == "table"){
      return (
        <div className="page_button"
          style={{ width: "180px", height: "30px", fontSize: "20px", marginRight: "5px" }}
          title={getLabel("LabelInput", (!Access.canWrite ? "Display" : "Edit"))}
          onClick={() => setTableModal(true)}
        >
          <div className="styleinput_preview_col" style={{ width: "30%" }}>
            {!Access.canWrite || loading || ReadOnly ? <MdOutlineRemoveRedEye /> : <MdMode />}
          </div>
          <div className="styleinput_preview_col" style={{ width: "70%" }}>
            {getLabel("LabelInput", (!Access.canWrite ? "Display" : "Edit"))}
          </div>
        </div>
      );
    }
    else if (form.variableTypeCode == "sensor")
    {
      return (
        <div className="page_button"
          style={{ width: "180px", height: "30px", fontSize: "20px", marginRight: "5px" }}
          title={getLabel("LabelInput", (!Access.canWrite || ReadOnly ? "Display" : "Edit"))}
          onClick={() => setSensorModal(true)}
        >
          <div className="styleinput_preview_col" style={{ width: "30%" }}>
            {!Access.canWrite || ReadOnly ? <MdOutlineRemoveRedEye /> : <MdMode />}
          </div>
          <div className="styleinput_preview_col" style={{ width: "70%" }}>
            {getLabel("LabelInput", (!Access.canWrite || ReadOnly ? "Display" : "Edit"))}
          </div>
        </div>
      );
    }
    else{
      return null;
    }
    
  };

  const onClickDuplicate = async() => {

    setIsUpdate(false);

    await OnDuplicate(form);


  };


  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        {tableModal &&
          <VariableDesignerTable
            IsDesktop={IsDesktop}
            Access={Access}
            OnCloseModal={() => setTableModal(false)}
            OnSave={onChangeDataTable}
            Data={form.data}
          />
        }
        {sensorModal &&
          <VariableDesignerSensor
            IsDesktop={IsDesktop}
            Access={Access}
            ReadOnly={ReadOnly}
            OnCloseModal={() => setSensorModal(false)}
            OnSave={onChangeDataSensor}
            Data={form.data}
          />
        }
        {validation.length > 0 && 
          <VariableDesignerValidation
            Validation={validation}
            OnCloseModal={() => setValidation([])}
          />
        }
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont">
          {getLabel("VariableDesignerModal", "Variable")}
        </div>
        {(Access.canWrite == true && !ReadOnly && isUpdate == true) &&
          <div className="page_modal_header_action_cont" style={{minHeight: "40px"}}>
            <ActionButton
              IsDesktop={IsDesktop}
              Label={getLabel("VariableDesignerModal", "Duplicate")}
              Icon={MdContentCopy}
              Disabled={loading}
              OnClick={onClickDuplicate}
              buttonStyle={{ fontSize: "80%", marginRight: "10px" }}
            />
          </div>
        }
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Variable", "name")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input " + (error["name"] ? "page_modal_body_col_input_error" : "")}
                value={form.name || ""}
                onChange={onChangeName}
                type="text"
                style={{ width: "100%" }}
                disabled={!Access.canWrite || loading || ReadOnly}
              />
              {error["name"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["name"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Variable", "description")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input " + (error["description"] ? "page_modal_body_col_input_error" : "")}
                value={form.description || ""}
                onChange={onChangeDescription}
                type="text"
                style={{ width: "100%" }}
                disabled={!Access.canWrite || loading || ReadOnly}
              />
              {error["description"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["description"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Variable", "variableTypeLabel")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "200px" }} >
              <select
                value={form.variableType}
                className={"page_select_input " + (error["variableType"] ? "auth_fill_row_input_error " : "")}
                onChange={onChangeVariableType}
                style={{ width: "100%", textAlign: "center", color: "black" }}
                disabled={!Access.canWrite || loading || ReadOnly}
              >
                <option value="" hidden style={{ textAlign: "center" }}></option>
                {variableType.map((o, index) => (
                  <option key={index} value={o._id} style={{ textAlign: "center", color: "black" }}>
                    {o.label}
                  </option>
                ))}
              </select>
              {error["variableType"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["variableType"]}
                </div>
              }
            </div>
          </div>
          {form.variableType && (
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Variable", "dataToDisplay")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              {displayDataForm()}
              {
                error["data"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["data"]}
                </div>
              }      
            </div>
          </div>
          )}
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Variable", "isParameter")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              <label className="page_switch">
                <input
                  type="checkbox"
                  checked={form.isParameter || false}
                  onChange={onChangeIsParameter}
                  disabled={!Access.canWrite || loading || (form.variableTypeCode == "sensor" || form.variableTypeCode == "table")}
                />
                <span className="page_slider round" />
              </label>
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_Variable", "order")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "100px" }} >
              <input
                className={"page_text_input " + (error["order"] ? "page_modal_body_col_input_error" : "")}
                value={form.order || ""}
                onChange={onChangeOrder}
                type="text"
                style={{ width: "100%" }}
                disabled={!Access.canWrite || loading || ReadOnly}
              />
              {error["order"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["order"]}
                </div>
              }
            </div>
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {(Access.canWrite && !ReadOnly) &&
            <Fragment>
              {isUpdate == true &&
                <input
                  type="button"
                  className="page_button page_modal_footer_button"
                  value={getLabel("App", "Delete")}
                  style={{ backgroundColor: "#b30000", maxWidth: "200px" }}
                  onClick={(loading) ? undefined : onClickDelete}
                  disabled={loading}
                />
              }
              <input
                type="button"
                className="page_button page_modal_footer_button"
                value={getLabel("App", "Confirm")}
                style={{ backgroundColor: "#52a3e7", maxWidth: "200px" }}
                onClick={(loading) ? undefined : onClickConfirm}
                disabled={loading}
              />
            </Fragment>
          }
        </div>
      </div>
    </div>
  );

};

export default VariableDesignerModal